// @ts-nocheck
import React from 'react'

import { FeatureFlag } from 'components/auth/FeatureFlag'

const StaffOnly = props => <FeatureFlag staffOnly {...props} />

export default StaffOnly